import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { Homesectionimage } from "../Data/ComponentsData/componentsdata";
import AnimationCommon from "../common/AnimationCommon";
import Footer from "../components/footer";
import Subscribe from "../components/subscribe";
import CountDown from "./CountDown";

const ComingSoon = () => {
  useEffect(() => {
    document.body.classList.remove("inner-page");
  }, []);

  return (
    <div>      
      <section className='auth-page'>
        <AnimationCommon />
        <Container className='cooming-soon'>
          <Row className='mb-50'>
            <Col md='6' className='left'>
              <div className='clock-box'>
                <div>
                  <div className='mb-4'>
                    <h2>We Are Launching Soon</h2>
                  </div>
                  <CountDown />
                </div>
              </div>
            </Col>
            <Col md='6'>
              <div className='home-right position-relative'>
                {Homesectionimage.map((image, index) => (
                  <div key={index} className={image.class}>
                    <img src={image.src} alt={image.alt} className='img-fluid' />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Subscribe />
      <Footer />
    </div>
  );
};

export default ComingSoon;
